<section
  [id]="formId"
  role="region"
  class="orientation-form"
  [class.orientation-form--height]="(resultToDisplay$ | async) === QuestionValues.LocalMission"
  [style.height]="formHeight$ | async"
>
  <div
    #formDescription
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
    *ngIf="(resultToDisplay$ | async) === null || (isMobileOrTablet$ | async) === true"
    class="orientation-form__description"
  >
    <h2 class="orientation-form__description__title">Contrat d&apos;Engagement Jeune, je me lance&nbsp;!</h2>
    <p>
      Pour entrer en Contrat d&apos;Engagement Jeune, vous devez vous rapprocher d&apos;un professionnel de
      l&apos;accompagnement chez Pôle Emploi ou en Mission Locale. Pour vous aider à identifier l&apos;interlocuteur à
      contacter, répondez à ces quelques questions.
    </p>
  </div>

  <div
    #formQuestions
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
    *ngIf="(resultToDisplay$ | async) === null && currentQuestion$ | async as currentQuestion; else displayConfirmation"
    class="orientation-form__questions"
    id="orientation-form-scroll"
  >
    <ng-container *ngFor="let value of questionValues; trackBy: trackByString">
      <app-cej-simple-choice-question
        [@fadeInOnEnter]
        [@fadeOutOnLeave]
        *ngIf="value === currentQuestion.value && !currentQuestion.isMultipleChoice"
        [question]="currentQuestion"
        [displayReturn]="currentQuestion.value !== QuestionValues.Accompagnement"
        (answer)="answerClicked($event, currentQuestion.value)"
        (return)="returnClicked($event)"
      ></app-cej-simple-choice-question>
      <app-cej-multiple-choices-question
        [@fadeInOnEnter]
        [@fadeOutOnLeave]
        *ngIf="value === currentQuestion.value && currentQuestion.isMultipleChoice"
        [question]="currentQuestion"
        [displayReturn]="currentQuestion.value !== QuestionValues.Accompagnement"
        (submittedAnswers)="answersSubmitted($event)"
        (return)="returnClicked($event)"
      ></app-cej-multiple-choices-question>
    </ng-container>
  </div>

  <ng-template #displayConfirmation>
    <section
      #formResult
      [@fadeInOnEnter]
      [@fadeOutOnLeave]
      *ngIf="resultToDisplay$ | async as resultToDisplay"
      class="orientation-form-result"
      [class.orientation-form-result--local-mission]="resultToDisplay === QuestionValues.LocalMission"
      [style.top]="resultTop$ | async"
    >
      <ng-container [ngSwitch]="resultToDisplay">
        <app-cej-orientation-solutions
          class="orientation-form-result__card"
          *ngSwitchCase="QuestionValues.OneJOneS"
          (closeEvent)="closeResult('Dispositifs 1J1S')"
        ></app-cej-orientation-solutions>
        <app-cej-result-card
          class="orientation-form-result__card"
          *ngSwitchCase="QuestionValues.PeContact"
          [cardConfig]="cardConfigPeAdvisor"
          (tracker)="trackResult('Click Conseiller PE')"
          (closeEvent)="closeResult('Conseiller PE')"
        ></app-cej-result-card>
        <app-cej-result-card
          class="orientation-form-result__card"
          *ngSwitchCase="QuestionValues.PeSignUp"
          [cardConfig]="cardConfigPeInscription"
          (tracker)="trackResult('Click Inscription PE')"
          (closeEvent)="closeResult('Inscription PE')"
        ></app-cej-result-card>
        <app-cej-v2-form-contact-modal
          *ngSwitchCase="QuestionValues.LocalMission"
          (tracker)="trackResult('Click Etre rappelé ML')"
          (closeEvent)="closeResult('Formulaire ML')"
        ></app-cej-v2-form-contact-modal>
      </ng-container>
    </section>
  </ng-template>
</section>
